import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import translate from '@translate';
import {
    createTransportPackageTypeDetailFetchFailure,
    createTransportPackageTypeDetailFetchSuccess,
    deleteTransportPackageTypeDetailFetchFailure,
    deleteTransportPackageTypeDetailFetchSuccess,
    getTransportPackageTypeDetailFetchFailure,
    getTransportPackageTypeDetailFetchSuccess,
    updateTransportPackageTypeDetailFetchFailure,
    updateTransportPackageTypeDetailFetchSuccess,
} from './reducer';
import { TransportPackageType, TransportPackageTypeDetailResType } from 'src/types/transportPackageType';

const getRequest = async (ssrcCode: string) => {
    const res = await api('get', `api/secure/transports/package-types/${encodeURIComponent(ssrcCode)}`);
    return res.data;
};

function* getFetch(action: { type: string; payload: string }) {
    try {
        const response: TransportPackageTypeDetailResType = yield call(getRequest, action.payload);
        yield put(getTransportPackageTypeDetailFetchSuccess(response));
    } catch (error) {
        yield put(getTransportPackageTypeDetailFetchFailure());
    }
}

export function* getTransportPackageTypeDetailFetchWatch() {
    yield takeEvery('transportPackageTypeDetail/getTransportPackageTypeDetailFetch', getFetch);
}

const createRequest = async (data: TransportPackageType) => {
    const res = await api('post', 'api/secure/transports/package-types', data);
    return res.data;
};

function* createFetch(action: { type: string; payload: TransportPackageType }) {
    try {
        const response: TransportPackageTypeDetailResType = yield call(createRequest, action.payload);
        yield put(
            createTransportPackageTypeDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('transportPackageTypeDetail.message.created') },
            })
        );
    } catch (error) {
        yield put(createTransportPackageTypeDetailFetchFailure());
    }
}

export function* createTransportPackageTypeDetailFetchWatch() {
    yield takeEvery('transportPackageTypeDetail/createTransportPackageTypeDetailFetch', createFetch);
}

const updateRequest = async (params: { ssrcCode: string; data: Partial<TransportPackageType> }) => {
    const res = await api(
        'put',
        `api/secure/transports/package-types/${encodeURIComponent(params.ssrcCode)}`,
        params.data
    );
    return res.data;
};

function* updateFetch(action: {
    type: string;
    payload: { ssrcCode: string; data: Partial<TransportPackageType> };
}) {
    try {
        const response: TransportPackageTypeDetailResType = yield call(updateRequest, action.payload);
        yield put(
            updateTransportPackageTypeDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('transportPackageTypeDetail.message.updated') },
            })
        );
    } catch (error) {
        yield put(updateTransportPackageTypeDetailFetchFailure());
    }
}

export function* updateTransportPackageTypeDetailFetchWatch() {
    yield takeEvery('transportPackageTypeDetail/updateTransportPackageTypeDetailFetch', updateFetch);
}

const deleteRequest = async (ssrcCode: string) => {
    const res = await api('delete', `api/secure/transports/package-types/${encodeURIComponent(ssrcCode)}`);
    return res.data;
};

function* deleteFetch(action: { type: string; payload: string }) {
    try {
        const response: TransportPackageTypeDetailResType = yield call(deleteRequest, action.payload);
        yield put(
            deleteTransportPackageTypeDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('transportPackageTypeDetail.message.deactivated') },
            })
        );
    } catch (error) {
        yield put(deleteTransportPackageTypeDetailFetchFailure());
    }
}

export function* deleteTransportPackageTypeDetailFetchWatch() {
    yield takeEvery('transportPackageTypeDetail/deleteTransportPackageTypeDetailFetch', deleteFetch);
}
